import React from "react";
import { Edit, SimpleForm, TextInput, required } from "react-admin";
import { editTitle } from "../../../../customStyles/ra-custom-styles";
import { Typography } from "@mui/material";

const EditPublicProcurementActProcedures = () => {
  return (
    <Edit
      title="Процедура (номенклатура)"
      mutationMode="pessimistic"
      sx={editTitle}
    >
      <Typography sx={editTitle}>Редакция на процедура</Typography>
      <SimpleForm>
        <TextInput
          label="Име"
          source="name"
          validate={[required()]}
          multiline
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
};

export default EditPublicProcurementActProcedures;
